import { api } from "../HttpService.js";

export const verifyClient = async (cnpjCpf) =>
  await api.integrations.get(`/omie/clients/verify/${cnpjCpf}`);

export const verifyContract = async (cnpjCpf) =>
  await api.integrations.post(`omie/rest/contracts/list/document`, {
    filtrar_cnpj_cpf: cnpjCpf,
  });

export const verifyEntries = async (cnpjCpf) =>
  await api.integrations.post(`/omie/finance/entries`, {
    cnpj_cpf: cnpjCpf,
  });

export const genInvoice = async (codigo) =>
  await api.integrations.get(`/omie/finance/entries/bill/${codigo}`);

export const verifyRegister = async (cnpjCpf) =>
  await api.integrations.post(`/omie/rest/clients/list/`, {
    cnpj_cpf: cnpjCpf,
  });
